import React, { useState, useEffect } from 'react';
import CovenantListMobile from './covenantListMobile';
import CovenantListWeb from './covenantListWeb';

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

const CovenantListRouter = () => {
  const width = useWindowWidth();
  const MOBILE_BREAKPOINT = 768;

  return width < MOBILE_BREAKPOINT ? <CovenantListMobile /> : <CovenantListWeb />;
};

export default CovenantListRouter;
